<template>
  <editor
    api-key="nhjbmx99exid7a84e1s71pai4rrlfr4dnjjpgmu7p8wycqo6"
    :init="{
      height: 500,
      menubar: false,
      extended_valid_elements: 'span[*]',
      vmodel: 'userInput',
      selector: 'textarea',
      block_unsupported_drop: false,
      images_upload_handler: this.handleFileUpload,
      relative_urls : false,
      image_dimensions: false,
      image_prepend_url: 'http://35.192.231.16/mom-saas-shared-directory/',
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount'
      ],
      toolbar:
        'preview | image | table | undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code | help'
    }"
  />
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import FileService from '../../services/file.service'
export default {
  name: 'TinyMceEditor',
  data: function () {
  },
  components: {
    Editor
  },
  methods: {
    handleFileUpload: (blobInfo, success, failure) => {
      var formData = new FormData()
      formData.append('file', blobInfo.blob(), blobInfo.filename())
      FileService.uploadFile(formData, function (e) {
        console.log(e)
        let percentage = (e.loaded / e.total * 100)
        console.log( e.loaded/1000 + ' KB uploaded out of ' + e.total/1000 + ' KB (' + percentage.toFixed(2) + ')%')
      }).then(
        response =>{
          if(response.data.Status){
            success(response.data.Object.location)
          } else
            failure (response.data.Message)
        }
      )
    }
  }
}
</script>
